import { render } from "./AdminAccommodationDetailsView.vue?vue&type=template&id=3c3819ba&ts=true&lang=pug"
import script from "./AdminAccommodationDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminAccommodationDetailsView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__